import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Pagination, EffectCoverflow } from "swiper/modules";
import { AdData, MapOfBrands } from "~src/types/brandMapping";
import { useState } from "react";

type SliderData = AdData[];

export default function AdImageSlider({
  data,
  brand,
  expandImage,
}: {
  data: SliderData;
  brand: MapOfBrands;
  expandImage: (data: AdData, brand: MapOfBrands) => void;
}) {
  const [visibleSlides, setVisibleSlides] = useState(5);
  const totalSlides = data.length;

  // Handle slide change to load more images
  const handleSlideChange = (swiper: any) => {
    const currentSlideIndex = swiper.activeIndex;

    // Load more images as the user scrolls
    if (currentSlideIndex + 3 > visibleSlides && visibleSlides < totalSlides) {
      setVisibleSlides((prev) => Math.min(prev + 3, totalSlides));
    }
  };

  return (
    <div style={{ maxWidth: "160px", minWidth: "160px" }}>
      <Swiper
        effect="coverflow"
        loop={true}
        centeredSlides={true}
        slidesPerView={3}
        pagination={false}
        navigation={false}
        onSlideChange={handleSlideChange}
        modules={[Pagination, EffectCoverflow]}
        className="mySwiper"
      >
        {data.slice(0, visibleSlides).map((item, index) => {
          if (!item.ad_image && !item.ad_video) return null;

          return (
            <SwiperSlide key={item.page_id + index}>
              {item.ad_video ? (
                <video
                  width="100px"
                  poster={item.ad_image}
                  onClick={() => expandImage(item, brand)}
                  onError={(e) => {
                    //@ts-ignore
                    e.target.poster =
                      "/assets/illustrations/illustration_no_product_image.png";
                  }}
                >
                  <source src={item.ad_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={item.ad_image}
                  alt=""
                  style={{ width: "100px" }}
                  loading="lazy"
                  onClick={() => expandImage(item, brand)}
                  onError={(e) => {
                    //@ts-ignore
                    e.target.src =
                      "/assets/illustrations/illustration_no_product_image.png";
                  }}
                />
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
